import React from 'react';
import { IconWarning, dlsColorWarning } from '@americanexpress/dls-react';
import { FxJourneyCompletionPage } from 'axp-fx-common';
import RegisterLayout from '../RegisterLayout';
import labels from '../../../constants/labels';

const RSVP_ERROR_MESSAGE =
  'This registration link is no longer valid. It may have expired, already been used, or been cancelled.';

const RSVP_ADDITIONAL_MESSAGE = labels.AMEX_REP_HELP_MESSAGE;

/**
 * Landing page for an invalid registration (RSVP) link. The RSVP is validated by
 * an external service when the user clicks the email link; if it is expired, used,
 * or cancelled, that service redirects here to inform the user. This is a terminal
 * message (no CTA) — the link cannot be retried.
 */
const RsvpErrorPage = () => (
  <RegisterLayout centerContent>
    <FxJourneyCompletionPage
      status="failed"
      icon={<IconWarning size="lg" theme={dlsColorWarning} />}
      heading="Unable to Continue Registration"
      details={RSVP_ERROR_MESSAGE}
      additionalDetails={RSVP_ADDITIONAL_MESSAGE}
    />
  </RegisterLayout>
);

export default RsvpErrorPage;
